import { Routes } from '@angular/router';

import { BlankLayoutComponent } from './common/layouts/blankLayout.component';
import { BasicLayoutComponent } from './common/layouts/basicLayout.component';
import { HomeComponent } from './common/layouts/home/home.component';
import { LoginComponent } from './common/layouts/login/login.component';
import { AuthGuard, PrepareGuard } from './core/core.module';

export const ROUTES: Routes = [
    { path: '', redirectTo: 'home', pathMatch: 'full' },

    // {
    //     path: 'people',
    //     component: BasicLayoutComponent,
    //     loadChildren: 'app/people/people.module#PeopleModule',
    //     canActivate: [AuthGuard, PrepareGuard]
    // },
    // {
    //     path: 'nursery',
    //     component: BasicLayoutComponent,
    //     loadChildren: 'app/people/people.module#PeopleModule',
    //     canActivate: [AuthGuard, PrepareGuard]
    // },
    // {
    //     path: 'messages',
    //     component: BasicLayoutComponent,
    //     loadChildren: 'app/messages/messages.module#MessagesModule',
    //     canActivate: [AuthGuard, PrepareGuard]
    // },
    // {
    //     path: 'giving',
    //     component: BasicLayoutComponent,
    //     loadChildren: 'app/giving/giving.module#GivingModule',
    //     canActivate: [AuthGuard, PrepareGuard]
    // },
    // {
    //     path: 'interests',
    //     component: BasicLayoutComponent,
    //     loadChildren: 'app/interests/interests.module#InterestsModule',
    //     canActivate: [AuthGuard, PrepareGuard]
    // },
    // {
    //     path: 'involvement',
    //     component: BasicLayoutComponent,
    //     loadChildren: 'app/involvement/involvement.module#InvolvementModule',
    //     canActivate: [AuthGuard, PrepareGuard]
    // },
    // {
    //     path: 'admin',
    //     component: BasicLayoutComponent,
    //     loadChildren: 'app/admin/admin.module#AdminModule',
    //     canActivate: [AuthGuard, PrepareGuard]
    // },
    // {
    //     path: 'portal',
    //     component: BasicLayoutComponent,
    //     loadChildren: 'app/member-portal/member-portal.module#MemberPortalModule',
    // },
    // { path: 'secretary', component: BasicLayoutComponent, loadChildren: 'app/secretary/secretary.module#SecretaryModule', canActivate: [AuthGuard, PrepareGuard] },
    {
        path: '',
        component: BasicLayoutComponent,
        children: [
            {
                path: 'home',
                component: HomeComponent,
                data: { title: 'Home' },
                canActivate: [AuthGuard, PrepareGuard],
            },
        ],
    },
    {
        path: '',
        component: BasicLayoutComponent,
        children: [
            {
                path: 'login',
                component: LoginComponent,
                data: { title: 'Login' },
            },
        ],
    },

    // Handle all other routes
    { path: '**', redirectTo: 'home' },
];
